module.exports = __webpack_public_path__ + "static/img/4.0f476c5.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/4/1/zh/4.png
// module id = K33I
// module chunks = 0